module.exports = __webpack_public_path__ + "assets/img/print1.6001ec48.png";